import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { HttpService } from 'src/app/http.service';
import { ProductUnit } from 'src/app/product/product-unit.service';

@Component({
  selector: 'app-by-product-list-add',
  templateUrl: './by-product-list-add.component.html',
  styleUrls: ['./by-product-list-add.component.scss']
})
export class ByProductListAddComponent implements OnInit {


  productGroupForm: FormGroup;
  product_units: ProductUnit[];


  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<ByProductListAddComponent>, private httpService: HttpService) {
    this.productGroupForm = this.fb.group({
      name: ['', Validators.required],           // Name field, required
      accountCode: ['', Validators.required],    // Account code field, required
      hsnCode: ['', Validators.required],        // HSN code field, required
      unitId: ['', Validators.required]          // Unit ID field, required
    });


    // get product unit
    this.httpService.getbyproductunit().subscribe((data: any[]) => {
      console.log(data);
      this.product_units = data;
    }, (error) => {
      console.log(error);
    });
  }

  ngOnInit() {
  }


  saveprodugroup() {

    const data_dict = {
      "name": this.productGroupForm.value.name,
      "account_code": this.productGroupForm.value.accountCode,
      "hsn_code": this.productGroupForm.value.hsnCode,
      "unit_id": this.productGroupForm.value.unitId
    }

    this.httpService.byproductmasteradd(data_dict).subscribe((data) => {

    }, (error) => {
      console.error(error);
    });
  }
}
